import { render, staticRenderFns } from "./MerchandiseDetailsInput.vue?vue&type=template&id=75fac1ca&scoped=true&"
import script from "./MerchandiseDetailsInput.vue?vue&type=script&lang=js&"
export * from "./MerchandiseDetailsInput.vue?vue&type=script&lang=js&"
import style0 from "./MerchandiseDetailsInput.vue?vue&type=style&index=0&id=75fac1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fac1ca",
  null
  
)

export default component.exports